export default __webpack_public_path__ + "static/desk08-bdbd397cc816baa4be60ec7f6dab568f.png";